/**
 * ChatTeaser — teaser proattivo del chat bubble (appare dopo 60s).
 * ★ Round 2 qualità — estratto da AIChatBubble.jsx. Testid invariati.
 */
import React from 'react';
import { X, Sparkles } from 'lucide-react';

export function ChatTeaser({ greeting, onOpen, onDismiss }) {
  return (
    <div
      className="fixed bottom-24 right-4 md:bottom-28 md:right-6 z-[7000] max-w-[320px] md:max-w-[360px] animate-in slide-in-from-bottom-2 fade-in duration-300"
      data-testid="ai-chat-teaser"
    >
      <button
        type="button"
        onClick={onOpen}
        className="block text-left bg-[var(--surface-1)] rounded-2xl p-4 pr-10 shadow-[0_25px_60px_-15px_rgba(0,0,0,0.4)] border border-[var(--gp-gold)]/30 hover:border-[var(--gp-gold)]/60 transition-colors w-full group"
      >
        <div className="flex items-start gap-3">
          <div className="relative shrink-0">
            <div className="w-10 h-10 rounded-full bg-[var(--gp-forest)] text-[var(--gp-gold)] flex items-center justify-center font-serif text-base">
              R
            </div>
            <span className="absolute -bottom-0.5 -right-0.5 w-3.5 h-3.5 rounded-full bg-[#22c55e] border-2 border-[var(--surface-1)]" />
          </div>
          <div className="min-w-0">
            <div className="flex items-center gap-1.5 text-[10px] tracking-[0.2em] uppercase text-[var(--gp-forest)]/60 font-semibold">
              <Sparkles className="w-3 h-3 text-[var(--gp-gold)]" />
              Assistant · online
            </div>
            <div className="font-serif text-[14px] md:text-[15px] text-[var(--gp-forest)] leading-snug mt-1">
              {greeting}
            </div>
            <div className="mt-2 text-[11px] text-[var(--gp-gold)] font-semibold inline-flex items-center gap-1 group-hover:underline">
              Apri la chat
              <span className="text-base leading-none">→</span>
            </div>
          </div>
        </div>
      </button>
      <button
        type="button"
        onClick={onDismiss}
        className="absolute top-2 right-2 w-6 h-6 rounded-full hover:bg-[var(--gp-forest)]/10 text-[var(--gp-forest)]/50 hover:text-[var(--gp-forest)] flex items-center justify-center"
        aria-label="Chiudi suggerimento"
        data-testid="ai-chat-teaser-dismiss"
      >
        <X className="w-3.5 h-3.5" />
      </button>
    </div>
  );
}
